export default {
	'loading': 'Loading...',
	'Sign in with FACEBOOK': 'Sign in with Facebook',
	'Sign in with GOOGLE': 'Sign in with Google',
	'Sign in with LINKEDIN': 'Sign in with Linkedin',
};
